import { localizedJsonText } from './localizedJsonText';

/** Event.city = cities koleksiyonu document id (slug). */

const EN_FALLBACK = {
  nicosia: 'Nicosia',
  famagusta: 'Famagusta',
  iskele: 'Iskele',
  kyrenia: 'Kyrenia',
  larnaca: 'Larnaca',
  lefke: 'Lefke',
  limassol: 'Limassol',
  morphou: 'Morphou',
  paphos: 'Paphos',
  turkey: 'Turkey',
};

/**
 * @param {string} cityId
 * @param {Function} [translate] react-admin translate
 */
export const formatCityId = (cityId, translate) => {
  if (cityId === undefined || cityId === null || cityId === '') return 'N/A';
  const key = String(cityId).toLowerCase();
  const fallback = EN_FALLBACK[key] ?? key.charAt(0).toUpperCase() + key.slice(1);

  if (typeof translate === 'function') {
    return translate(`cities.${key}`, { _: fallback });
  }

  return fallback;
};

export const cityNameFromRecord = (record, locale = 'en') => {
  if (!record) return formatCityId(null);
  const fromJson = localizedJsonText(record.name, locale, '');
  if (fromJson) return fromJson;
  if (typeof record.name === 'string') return record.name;
  return formatCityId(record.id);
};
